module.exports = __webpack_public_path__ + "static/media/author.17384667.svg";